import { render } from "./trainingMaterials.vue?vue&type=template&id=b066ab44&scoped=true"
import script from "./trainingMaterials.js?vue&type=script&lang=js"
export * from "./trainingMaterials.js?vue&type=script&lang=js"

import "./trainingMaterials.vue?vue&type=style&index=0&id=b066ab44&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b066ab44"]])

export default __exports__